import * as React from 'react';
import { useMemo } from 'react';

import get from 'lodash/get';
import {
  BaseTable,
  employeesRowKey,
  getEmployeesRowId,
  PropsType,
  useAppliedFilter,
} from 'shared-feature-stats';

import {
  Alert,
  useGridApiRef,
  useKeepGroupedColumnsHidden,
} from '@sbv-clients/ui-shared';

import { facilitiesColumns, groupingColDef } from './columns';

export function FacilitiesEmployeesGrid({
  tab,
  data,
  isLoading,
  isError,
  error,
  filterByWeekend,
  groupByShift,
}: PropsType) {
  const filterModel = useAppliedFilter(tab, filterByWeekend);
  const rowGroupingModel = useMemo(
    () =>
      groupByShift
        ? [employeesRowKey('facilityName'), employeesRowKey('shiftSchedulerId')]
        : [employeesRowKey('facilityName')],
    [groupByShift]
  );
  const apiRef = useGridApiRef();
  const initialState = useKeepGroupedColumnsHidden({
    apiRef,
    initialState: {
      rowGrouping: { model: rowGroupingModel },
      pagination: { paginationModel: { pageSize: 10 } },
      columns: {
        columnVisibilityModel: {
          [employeesRowKey('fullName')]: false,
        },
      },
      aggregation: {
        model: {
          [employeesRowKey('dismissed')]: 'sum',
          [employeesRowKey('interested')]: 'sum',
          [employeesRowKey('notified')]: 'sumBothNotified',
          [employeesRowKey('assigned')]: 'sumBothAssigned',
          [employeesRowKey('isActive')]: 'ratio',
          [employeesRowKey('isOnboarded')]: 'ratio',
          [employeesRowKey('isRegistered')]: 'ratio', // [rowKey('saasRole')]: 'noop',
        },
      },
    },
  });

  if (isError) {
    return (
      <Alert severity={'error'}>
        {get(error, 'message', 'There was an error retrieving employees')}
      </Alert>
    );
  }

  return (
    <BaseTable
      rowGroupingModel={rowGroupingModel}
      filterModel={filterModel}
      rows={data}
      columns={facilitiesColumns}
      apiRef={apiRef}
      loading={isLoading}
      getRowId={getEmployeesRowId}
      initialState={initialState}
      groupingColDef={groupingColDef}
    />
  );
}
